import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import { RequestDataType, RequestHeaderType, ResponseDataType } from 'src/types/api'
import { ERRCODES_COMMON } from 'src/service/constant/errcodes'
import { Cookies } from 'react-cookie'
import { handleDeviceDetect } from 'src/provider/ChannelContextProvider'
import { Bridge } from 'src/utils/bridge'
import { decryptPhoneNumber } from 'src/utils'
import { CMDTYPES } from 'src/service/constant/cmdtypes'
import { captureApiResponseError } from 'src/utils/sentry/apiResponseError'

class HttpData<T> {
  Header: RequestHeaderType
  Body?: T

  constructor(CmdType: number, Body?: T) {
    this.Header = {
      RequestID: this.gri(),
      Channel: this.getChannel(),
      CmdType: CmdType,
    }
    this.Body = Body
  }

  private getChannel(): 'web' | 'aos' | 'ios' {
    return window.location.pathname.substring(1, 4) as 'web' | 'aos' | 'ios'
  }

  // generateRandomNumber
  private static grn(): string {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }

  // generateRequestID
  private gri(): string {
    return `${HttpData.grn()}${HttpData.grn()}-${HttpData.grn()}-${HttpData.grn()}-${HttpData.grn()}-${HttpData.grn()}${HttpData.grn()}${HttpData.grn()}`
  }
}

const httpData = <T>(Cmdtype: number, Body?: T): RequestDataType<T> => {
  return new HttpData(Cmdtype, Body)
}

const cookies = new Cookies()

class CustomAxios {
  private axiosInstance: AxiosInstance
  private readonly baseURL: string

  constructor() {
    this.baseURL = process.env.REACT_APP_SERVER_BASE_URL as string
    // this.baseURL = 'https://mcrs.couponwallet.co.kr'

    this.axiosInstance = axios.create({
      baseURL: this.baseURL,
    })

    // 응답 인터셉터 설정
    this.axiosInstance.interceptors.response.use(
      (response) => {
        if (response.status === 204) {
          window.location.reload()
          alert('잘못된 요청입니다. 다시 시도해주세요.')
        }
        return response.status !== 200 ? new Promise(() => {}) : response
      },
      (error) => {
        return Promise.reject(error)
      },
    )
  }

  //T : request Body Type
  //U : response Body Type
  async post<T, U>(CmdType: number, Body?: T): Promise<ResponseDataType<U>> {
    const { channel } = handleDeviceDetect()
    try {
      return await this.axiosInstance
        .post('', JSON.stringify(httpData<T>(CmdType, Body)), { withCredentials: true })
        .then(async (res: AxiosResponse<ResponseDataType<U>>) => {
          const { data } = res
          switch (data?.Header?.ErrCode) {
            //없는 전문
            case ERRCODES_COMMON.SYSTEMS_ERROR:
              if (!window.location.pathname?.includes('system_notice')) {
                window.location.replace(`${window.location.origin}/${channel}/system_notice`)
              }
              break
            //사용자 임의 조작
            case ERRCODES_COMMON.AUTH_ERROR:
            case ERRCODES_COMMON.SERVER_INTERNAL_ERROR:
              console.warn(CmdType)
              // window.location.href = `${window.location.origin}/${channel}/error/${CmdType}/${data?.Header?.ErrCode}`
              break
            // 세션 없음
            case ERRCODES_COMMON.SESSION_ERROR:
            case ERRCODES_COMMON.ERROR_LOGOUT:
              if (
                window.location.pathname?.includes('billgate') ||
                window.location.pathname?.includes('danal')
              ) {
                window.location.replace(
                  `${window.location.origin}/${channel}/coupon/payment/finish/0`,
                )
              } else if (window.location.pathname?.includes('pass')) {
              } else {
                // Bridge.handleReqDeleteInfo()
                // cookies.remove('u-tel', { path: '/' })
                // cookies.remove('auth-key', { path: '/' })
                !window.location.pathname?.includes('intro') &&
                  window.location.replace(`${window.location.origin}/${channel}/intro`)
              }
              console.warn(data?.Header?.ErrCode, data?.Header?.CmdType, 'session')
              break
            //간편로그인(PIN) 체크
            case ERRCODES_COMMON.PIN_CHECK_ERROR:
              const pinCheck = cookies.get('pin_check')
              const u_tel = cookies.get('u-tel')
              const c_tel = !!u_tel ? (decryptPhoneNumber(u_tel) as string) : ''
              if (!pinCheck && !!u_tel) {
                Bridge.handleReqEntryEasyLogin(c_tel)
              }
              if (CmdType !== CMDTYPES.Cancel) {
                return new Promise((resolve) => {
                  this.post<T, U>(CmdType, Body).then(resolve)
                })
              }
              break
            default:
              break
          }
          captureApiResponseError(data.Header)
          return data
        })
    } catch (error) {
      const { code } = error as AxiosError
      if ((code as string) === 'ERR_NETWORK' && !navigator.onLine) {
        window.location.reload()
      }
      console.error('Error POST request:', error)
      throw error
    }
  }
}

export const fetch = new CustomAxios()
